import {Box, Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {styled} from "@mui/material/styles"
import {useTranslation} from "react-i18next"
import {ReactNode} from "react"

import {SettlementInFullOptionLink} from "./SettlementInFullOptionLink"
import {SettlementPlanOptionLink} from "./SettlementPlanOptionLink"

import {CustomerFindPayload} from "@indebted/api/customer/customerFind"

function OffersOptionSection({
	PaymentOptions,
	Currency,
}: {
	PaymentOptions: CustomerFindPayload["PaymentOptions"]
	Currency: string
}) {
	const {t} = useTranslation()
	const settlementOptions = PaymentOptions.flatMap((option) => {
		let optionComponent: ReactNode | undefined = undefined
		if (option.Type === "SettlementInFull") {
			optionComponent = <SettlementInFullOptionLink {...option.Properties} Currency={Currency} />
		} else if (option.Type === "SettlementPlan") {
			optionComponent = <SettlementPlanOptionLink {...option.Properties} Currency={Currency} />
		}
		if (!optionComponent) {
			return null
		}

		return (
			<PaymentOptionGrid
				size={{xs: 12, md: 6}}
				key={`payment-option-${option.Type}`}
				data-testid={`payment-option-item-${option.Type}`}
			>
				{optionComponent}
			</PaymentOptionGrid>
		)
	}).filter((option) => option !== null)

	if (settlementOptions.length === 0) {
		return null
	}

	return (
		<Box component="section" alignContent="center" sx={{width: "100%", padding: "1.5rem 0rem 0px 0rem"}}>
			<Typography
				variant="h5"
				fontWeight={700}
				sx={{fontSize: "1.25rem", textAlign: "center", marginBottom: "0px"}}
				gutterBottom
			>
				{t("customer_get.outstanding_balance.limited_time_offer")}
			</Typography>
			<Typography
				variant="subtitle1"
				color="text.secondary"
				gutterBottom
				sx={{textAlign: "center", marginBottom: "0px"}}
			>
				{t("customer_get.outstanding_balance.pay_debt_for_less")}
			</Typography>

			<Grid container spacing={4} sx={{paddingTop: "20px"}}>
				{settlementOptions}
			</Grid>
		</Box>
	)
}

const PaymentOptionGrid = styled(Grid)`
	flex-grow: 1 !important;
`

export {OffersOptionSection}
